// extracted by mini-css-extract-plugin
export default {"sectionDisclaimer":"styles_sectionDisclaimer__15gYL","disclaimer":"styles_disclaimer__NY90g"};